export default __webpack_public_path__ + "static/ActionCardFullAnnotated-165d4233056659ef48a6911042e6690b.png";